import { alpha, Box, Button, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import { useRouter } from 'src/routes/hooks';
import { useAuthContext } from 'src/auth/hooks';
import { paths } from 'src/routes/paths';
import { updateProduct } from 'src/services/products.service';
import Iconify from '../iconify';
import DeleteProductDialog from './delete-product';


export default function ProductCard({ cardDetails }) {
  const router = useRouter();
  const { user } = useAuthContext();
  const {
    id,
    product_name,
    is_active,
    image_url,
    price,
    quantity,
    category,
    best_before,
    description,
  } = cardDetails;

  const onClickActivate = () => {
    updateProduct(id, { is_active: true }, user.clinic_id).then(() => {
      router.reload();
    });
  };

  const onClickDeactivate = () => {
    updateProduct(id, { is_active: false }, user.clinic_id).then(() => {
      router.reload();
    });
  };

  return (
    <Box sx={{ background: 'white', padding: 3, borderRadius: 2 }}>
      {image_url && image_url.length > 0 ? (
        <Box
          component="img"
          src={image_url[0]}
          alt={product_name}
          sx={{ width: '100%', height: 140, objectFit: 'cover', borderRadius: 2 }}
        />
      ) : (
        <Box
          sx={{
            height: 140,
            borderRadius: 2,
            bgcolor: (theme) => alpha(theme.palette.grey[500], 0.04),
            border: (theme) => `dashed 1px ${theme.palette.divider}`,
          }}
        />
      )}

      <Stack direction="row" justifyContent="space-between" alignItems="center" marginY="6px">
        <Typography fontSize={{ lg: '16px', xs: '12px' }}>{product_name}</Typography>
        <Stack direction="row">
          <IconButton
            onClick={() =>
              router.push(paths.clinic_dashboard.edit_product.replace(':productId', id))
            }
          >
            <Iconify icon="tabler:edit" />
          </IconButton>
          <DeleteProductDialog productId={id} clinicId={user.clinic_id} />
        </Stack>
      </Stack>

      {is_active ? (
        <Button
          variant="outlined"
          onClick={onClickDeactivate}
          sx={{
            width: 1,
            borderColor: '#D92D7F',
            color: '#D92D7F',
            fontSize: { lg: '16px', xs: '12px' },
          }}
        >
          Deactivate
        </Button>
      ) : (
        <Button
          variant="outlined"
          onClick={onClickActivate}
          sx={{
            width: 1,
            color: 'white',
            boxShadow: 10,
            background: '#D92D7F',
            ':hover': { background: '#D92D7F' },
            fontSize: { lg: '16px', xs: '12px' },
          }}
        >
          Activate
        </Button>
      )}
    </Box>
  );
}
